import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-rename-dialog',
  templateUrl: './rename-dialog.component.html',
  styleUrls: ['./rename-dialog.component.scss']
})
export class RenameDialogComponent implements OnInit {

  fileOrFolderName: string;
  constructor() { }

  ngOnInit() {
  }

}
